import { CustomCellEditorProps } from "ag-grid-react";
import { Input } from "antd";

type Props = CustomCellEditorProps;

function CurrencyCellEditor(props: Props) {
  const { onValueChange, value } = props;

  return (
    <div className="w-full !h-full flex items-center">
      <Input
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus
        type="number"
        value={value}
        onKeyDown={(evt) => evt.key === "e" && evt.preventDefault()}
        onChange={(event: any) => {
          onValueChange(event.target.value);
        }}
        min="0"
      />
    </div>
  );
}

export default CurrencyCellEditor;
